import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeResposta = (): TabelaColuna => ({
  Chave: 'nomeResposta',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Resposta</div>
})
